
import { Component, Prop, Vue } from "vue-property-decorator";
import Box from "@/components/boxes/Box.vue";
import BaseList from "@/components/base/BaseList.vue";
import { BoxEntity } from "@/entities/box.entity";

@Component({
  components: {
    Box,
    BaseList,
  },
})
export default class BoxList extends Vue {
  @Prop() value!: BoxEntity[];
  @Prop({ default: 20 }) loadingCount!: number;
}
